import { columnReducer } from '../slices/column';
import { taskReducer } from '../slices/task';
import { userReducer } from '../slices/user';

export default { columnReducer, taskReducer, userReducer };
